import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'

import { Row, Col, Checkbox } from 'react-bootstrap'
import ExpandedItems from '../ExpandedItems'

function Expanded({ items, store }) {
  const itemComps = items.map((item) => {
    const checked = store.itemStore.isSelected(item.id)

    const toggleItem = () => {
      store.itemStore.toggleItem(item.id)
    }

    return (
      <Row key={item.id}>
        <Col sm={12}>
          <ExpandedItems
            item={item}
            store={store}
            dataClassLabels={store.itemStore.dataClassLabels}>
            <Checkbox
              onChange={toggleItem}
              checked={checked}
              inline
              style={{ marginTop: '-1.5em' }}
            />
          </ExpandedItems>
        </Col>
      </Row>
    )
  })

  return <div>{itemComps}</div>
}

Expanded.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  store: PropTypes.object,
}

export default observer(Expanded)
